import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilCallback } from 'recoil'

import {
  LINK_VARIANT_HIGHLIGHT,
  Link,
  TruncateAndTooltip,
} from 'mailup-web-components'

import { evalCondition } from 'mailup-react-helpers'

import { panelEditRecipientOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'

interface MainItemProps {
  id: number
  label?: string
}

const MainItem: FC<MainItemProps> = ({ label, id }) => {
  const intl = useIntl()
  const canEdit = evalCondition('uo:EDIT') as boolean

  const panelOpen = useRecoilCallback(panelEditRecipientOpenCallback, [])

  const handleClick = (e: React.MouseEvent<HTMLLinkElement>): void => {
    e.stopPropagation()

    void panelOpen(id)
  }

  const emptyContent =
    label === null || label === undefined || label.length === 0

  return canEdit ? (
    <Link
      variant={LINK_VARIANT_HIGHLIGHT}
      onClick={handleClick}
      data-mu-test="edit-item"
    >
      {emptyContent ? (
        <em>{intl.formatMessage({ id: 'Load.RecipientsList.EmptyData' })}</em>
      ) : (
        <TruncateAndTooltip text={label} />
      )}
    </Link>
  ) : emptyContent ? (
    <em>{intl.formatMessage({ id: 'Load.RecipientsList.EmptyData' })}</em>
  ) : (
    <TruncateAndTooltip text={label} />
  )
}

export default MainItem
